import { SVGProps } from "react";

export function DisLikeIcon({
  stroke = "#D92D20",
  xmlns = "http://www.w3.org/2000/svg",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={15}
      height={16}
      viewBox={"0 0 15 16"}
      fill="none"
      xmlns={xmlns}
      {...props}
    >
      <path
        d="M14.375 9.25C14.375 9.58152 14.2433 9.89946 14.0089 10.1339C13.7745 10.3683 13.4565 10.5 13.125 10.5H9.175L9.775 13.3562C9.7875 13.4187 9.79375 13.4875 9.79375 13.5563C9.79375 13.8125 9.6875 14.05 9.51875 14.2188L8.85625 14.875L4.74375 10.7625C4.5125 10.5312 4.375 10.2188 4.375 9.875V3.625C4.375 3.29348 4.5067 2.97554 4.74112 2.74112C4.97554 2.5067 5.29348 2.375 5.625 2.375H11.25C11.7688 2.375 12.2125 2.6875 12.4 3.1375L14.2875 7.54375C14.3438 7.6875 14.375 7.8375 14.375 8V9.25ZM0.625 2.375H3.125V9.875H0.625V2.375Z"
        fill="#D92D20"
      />
    </svg>
  );
}
